export default {
  messages: {
    en: {},
    fr: {},
  },
};
